export enum Roles {
  admin = 'ADMIN',
  user = 'USER',
  employee1 = "EMPLOYER-I",
  employee2 = "EMPLOYER-II",
  employee3 = "EMPLOYER-III",
}
